export default __webpack_public_path__ + "static/media/filter.0615516a.svg";